import ApiService from "./api.service";

class PdfExportService extends ApiService {
    getVotingSummaryPdfFile(data) {
        return this.post(`pdf-creator/export-voting-summary`, data, { responseType: "arraybuffer" })
    }

    getBlockVotingsResultsToPDfFIle(pointId, sessionId) {
        return this.get(`pdf-creator/export-voting-block-results/${pointId}/${sessionId}`, { responseType: "arraybuffer" })
    }
   
    getInterpellationPdfFile(data) {
        return this.post(`pdf-creator/export-interpellation`, data, { responseType: "arraybuffer" })
    }

    getUserPresencePdfFile(data) {
        return this.post(`pdf-creator/user-presence`, data, { responseType: "arraybuffer" })
    }


}

export default new PdfExportService();
